export const roundToNearest = ( num, roundTo = 100 ) => {
	return Math.floor( num / roundTo ) * roundTo;
};

const isString = ( s ) => {
	return typeof ( s ) === 'string' || s instanceof String;
};

export const convertStringToNumber = ( str ) => {
	if ( ! str || ! isString( str ) ) {
		return;
	}
	const stripped = str.replaceAll( ',', '' ).replaceAll( '+', '' );
	return parseInt( stripped, 10 );
};

export const convertNumberToString = ( num ) => {
	if ( ! num ) {
		return;
	}
	return num.toLocaleString();
};
